import styled from 'styled-components'
import AvatarStyle from '@material-ui/core/Avatar'
import IconButtonStyle from "@material-ui/core/IconButton"

export const LogoNotification = styled.div`
  width: 30px;
  height: 30px;

  svg {
    color: #7D3CE8;
  }
`

export const Container = styled.div`
  width: 390px;
  height: 100%;
  padding: 16px;
  border-radius: 3px;
  background-color: #fff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
`

export const Header = styled.div`
  width: 357px;
  display: flex;
  align-items: start;
  cursor: pointer;
  gap: 8px;

`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 283px;
`

export const BodyName = styled.div`
  display: flex;
  align-items: flex-start;

  a {
    text-decoration: none;
    font-size: 16px;
    font-weight: 600;
    color: #48454C;
    cursor: pointer;
  }
`

export const Message = styled.div`
  width: 100%;
  height: fit-content;
  padding: 8px;
  border-radius: 3px;
  background-color: #F6F7FC;
  margin-top: 16px;

  a {
    text-decoration: none;
    color: #6B6871;
  }
`

export const Infos = styled.span`
  font-size: 12px;
  font-weight: 400;
  color: #B3ADBD;
`

 export const Avatar = styled(AvatarStyle)`
	&& {
	  width: 40px;
	  height: 40px;
	  font-size: 14px;
	  margin-right: 12px;
	}
`

export const Button = styled(IconButtonStyle)`
  svg {
    width: 10px;
    height: 10px;
    color: #8F8A97;
    cursor: pointer;
  }
`